import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { DateTimeFormat, formatDateTime } from '@occc-app/lib/date';
import { formatCompactNumber } from '@occc-app/lib/numbers';
import { TooltipContentProps } from '@occc/ui-design-system';

export const MyStoresChartTooltip = ({ payload }: TooltipContentProps) => {
  const theme = useTheme();
  // Prefer first item with a defined numeric value; fall back to first item.
  // This allows zero (0) values to be displayed instead of suppressing the tooltip.
  const item = payload?.find((item) => item.value != null && item.value !== 0) ?? payload?.[0];

  // Only hide when item or its value is null/undefined (not when value is 0)
  if (!item || item.value == null) {
    return null;
  }

  const formattedDate = formatDateTime(
    item.payload.date,
    DateTimeFormat.DayOfWeekWithShortMonthDate,
  );
  const color = item.value === 0 ? theme.palette.info.main : item.color;

  return (
    <Box sx={{ minWidth: 150 }}>
      <Typography variant='subtitle2' mb={1} noWrap>
        {formattedDate}
      </Typography>
      <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={1}>
        <Typography variant='caption' color='text.secondary'>
          Disconnected Stores
        </Typography>
        <Typography variant='subtitle2' sx={{ color }} noWrap>
          {formatCompactNumber(item.value)}
        </Typography>
      </Stack>
    </Box>
  );
};
